<template>
  <div>
    <!-- 인사교육 만족도 조사 -->
    <div class="overflow-y-auto">
      <v-row class="title-wrap d-flex flex-column">
        <v-col class="bg-title">인사교육 만족도 조사</v-col>
        <v-col class="bg-title-text">
          <p>{{ surveyNm }}</p>
          <p>{{ surveyGuide }}</p>
        </v-col>
      </v-row>

      <div class="px-6">
        <!--step-- value값: step진행-->
        <v-stepper value="1" elevation="0">
          <v-stepper-header class="stepper-style elevation-0">
            <div>{{ idx + 1 }} / {{ surveyCount }}</div>
          </v-stepper-header>
        </v-stepper>
        <!-- 제목 -->
        <v-row class="title-wrap mt-5">
          <v-col class="pa-0 text-left">
            <div class="text-h5 font-weight-bold point-green mb-1">
              Q{{ idx + 1 }}.
            </div>
            <v-subheader class="subheader-text">
              <v-badge color="pink" dot left>
                {{
                  surveyList[idx] === undefined ? '' : surveyList[idx].itemCntnt
                }}
              </v-badge></v-subheader
            >
          </v-col>
        </v-row>
        <!--라디오 버튼 -->
        <div v-if="surveyList[idx] !== undefined">
          <div
            class=""
            v-if="
              surveyList[idx].questType === 'S'
            "
          >
            <v-container fluid class="pa-0">
              <v-radio-group v-model="answer[idx]">
                <div v-for="(item, i) in surveyAnsItemList" :key="i">
                  <div v-if="item !== null && item.imgFileSeq === null">
                    <v-radio :value="Number(item.itemNo)" class="satis-survey-radio">
                      <template v-slot:label>
                        <div>{{ item.itemCntnt }}</div>
                      </template>
                    </v-radio>
                  </div>
                  <div v-else>
                    <v-radio :value="Number(item.itemNo)" class="satis-survey-card mb-5">
                      <template v-slot:label>
                        <v-list class="satis-img-text">
                          <v-list-item class="satis-img">
                            <v-img :src="$domain + 'api/file/survey?fileSeq=' + (item.imgFileSeq===null?'':item.imgFileSeq) + '&enterCd=' + $store.getters.GET_USER_DATA.ssnEnterCd" height="100%" cover class="bg-white"></v-img>
                          </v-list-item>
                          <v-list-item class="satis-text">
                            {{ item.itemCntnt }}
                          </v-list-item>
                        </v-list>
                      </template>
                    </v-radio>
                  </div>
                </div>
              </v-radio-group>
            </v-container>
            <!-- 서술형 -->
          </div>

          <div class="" v-if="surveyList[idx].questType === 'D'">
            <v-row
              class="title-wrap"

            >
              <v-col class="pa-0 text-left">
                <div class="text-h5 font-weight-bold point-green mb-1"></div>
                <!-- <v-subheader class="subheader-text">
                  추가했으면 하는 메뉴에 대해 기술해 주세요.
                </v-subheader> -->
              </v-col>
            </v-row>
            <!--카드형 설문 박스 -->
            <div class="">
              <v-textarea
                elevation="0"
                outlined
                name="input-7-4"
                placeholder="내용을 입력해주세요."
                class="color-dark-grey font-weight-regular"
                v-model="answer[idx]"
              ></v-textarea>
            </div>
          </div>

          <!-- 제목 -->
          <div class="" v-if="surveyList[idx].questType === 'M'">
            <v-row class="title-wrap">
              <v-col class="pa-0 text-left">
                <div class="text-h5 font-weight-bold point-green mb-1"></div>
                <v-subheader class="subheader-text">
                  (복수선택가능)
                </v-subheader>
              </v-col>
            </v-row>
            <!--카드형 설문 박스 -->
            <v-container fluid class="pa-0">
              <div v-for="(item, i) in surveyAnsItemList" :key="i">
                <div v-if="item !== null && item.imgFileSeq === null" >
                  <v-checkbox
                    v-model="checkAnswer"
                    :label="item.itemCntnt"
                    :value="item.itemNo"
                    class="satis-survey-check"
                    @change="checkUpdate(checkAnswer)"
                  ></v-checkbox>
                </div>
                <div v-else>
                  <v-checkbox
                        v-model="checkAnswer"
                        :label="item.itemCntnt"
                        :value="item.itemNo"
                        class="satis-survey-card mb-5"
                        @change="checkUpdate(checkAnswer)"
                        >
                      <template v-slot:label>
                        <v-list class="satis-img-text">
                          <v-list-item class="satis-img">
                            <v-img :src="$domain + 'api/file/survey?fileSeq=' + (item.imgFileSeq===null?'':item.imgFileSeq) + '&enterCd=' + $store.getters.GET_USER_DATA.ssnEnterCd" height="100%" cover class="bg-white"></v-img>
                          </v-list-item>
                          <v-list-item class="satis-text">
                            {{ item.itemCntnt }}
                          </v-list-item>
                        </v-list>
                      </template>
                    </v-checkbox>
                </div>
              </div>
            </v-container>
          </div>
        </div>
      </div>
    </div>

    <!--하단버튼-->
    <v-bottom-navigation fixed scroll-threshold="500" height="96">
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="6" class="pr-1">
          <v-btn block elevation="0" class="btn-fixed btn-white" @click="prev">
            <span class="black--text">이전</span>
          </v-btn>
        </v-col>
        <v-col cols="6" class="pl-1">
          <v-btn block elevation="0" class="btn-fixed btn-grey" @click="next">
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
  </div>
</template>

<script>
import routerNames from '@/const/routerConstants';
import {
  getBenSurveyDtl,
  getBenSurveyAppQstItemList,
  getBenSurveyAppAnsSelItemList,
  saveSurveyAnswer,
  saveSurveyCheckAnswer,
  getSurveySeqNo,
} from '@/api/workStatus';

import { mapGetters } from 'vuex';
//import PageHeader from '@/components/common/PageHeader.vue';

export default {
  data: () => ({
    surveyNm: '',
    surveyGuide: '',
    surveyList: [],
    idx: 0,
    answer: [],
    isTest: false,
    surveyCount: 0,
    surveyAnsItemList: [],
    checkAnswer: [],
    checkAnswerSave: [],
    saveAnswerData: [],
  }),

  components: {},

  computed: {
    ...mapGetters(['GET_ITEM', 'GET_IDX']),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_BTN
      }px;`;
    },
  },

  methods: {
    async checkUpdate(checkAnswer) {

      if (checkAnswer !== null) {
        this.checkAnswerSave = checkAnswer;
      }

      /*
      this.checkAnswerSave = [];
      if (checkAnswer.length > 5) {
        this.checkAnswerSave = {
          ...item,
          answer: checkAnswer[checkAnswer.length - 1],
        };
      } else {
        this.checkAnswerSave = {
          ...item,
          answer: 0,
        };
      }

      const params = {
        saveAnswerData: this.checkAnswerSave,
      };

      //await saveSurveyCheckAnswer(params);

      params.searchSurveyId = item.surveyId;
      params.itemId = item.itemId;

      let response = await getBenSurveyAppAnsSelItemList(params);

      this.surveyAnsItemList = response.data.data;

      let count = 0;

      for (let i = 0; i < this.surveyAnsItemList.length; i++) {
        if (this.surveyAnsItemList[i].questType === 'M') {
          if (count === 0) {
            this.checkAnswer = [];
            count++;
          }
          this.checkAnswer.push(Number(this.surveyAnsItemList[i].answer));
          this.countNext++;
        }
      }
      */

      //alert(checkAnswer);
      //alert(JSON.stringify(item));
    },

    async prev() {
      if (this.idx !== 0) {
        this.idx--;
      }

      const params = {
        searchSurveyId: this.GET_ITEM.surveyId,
        itemId: this.surveyList[this.idx].itemId,
      };

      let response = await getBenSurveyAppAnsSelItemList(params);

      this.surveyAnsItemList = response.data.data;

      let count = 0;

      for (let i = 0; i < this.surveyAnsItemList.length; i++) {
        if (this.surveyAnsItemList[i].questType === 'M') {

          if (count === 0) {
            this.checkAnswer = [];
            count++;
          }

          //alert(this.checkAnswerSave[i]);

          if (this.checkAnswerSave[i] !== null && this.checkAnswerSave[i] !== 0 && this.checkAnswerSave[i] !== undefined) {
            this.checkAnswer.push(Number(this.checkAnswerSave[i]));
          }
        }
      }
    },

    async next() {
      if (this.surveyList.length === this.idx + 1) {
        if (!confirm('설문조사를 종료 하시겠습니까?')) {
          return;
        }

        this.saveSurveyAnswer();
      }

      if (this.surveyList.length > this.idx + 1) {
        this.idx++;
      }

      const params = {
        searchSurveyId: this.GET_ITEM.surveyId,
        itemId: this.surveyList[this.idx].itemId,
      };

      let response = await getBenSurveyAppAnsSelItemList(params);

      this.surveyAnsItemList = response.data.data;

      let count = 0;

      for (let i = 0; i < this.surveyAnsItemList.length; i++) {
        if (this.surveyAnsItemList[i].questType === 'M') {

          if (count === 0) {
            this.checkAnswer = [];
            count++;
          }

          if (this.checkAnswerSave[i] !== null && this.checkAnswerSave[i] !== 0 && this.checkAnswerSave[i] !== undefined) {
            this.checkAnswer.push(Number(this.checkAnswerSave[i]));
          }
        }
      }

      //alert(this.checkAnswer);

    },

    async saveSurveyAnswer() {
      this.saveAnswerData = [];

      for (let i = 0; i < this.surveyList.length; i++) {
        if (this.surveyList[i].questType === 'M') {
          for (let j = 0; j < this.checkAnswer.length; j++) {
            if (this.checkAnswer[j] !== 0) {
              let params = {
                surveyId: this.surveyList[i].surveyId,
                surveyItemId: this.surveyList[i].itemId,
              }
              let response = await getSurveySeqNo(params);

              this.saveAnswerData.push({
                surveyId: this.surveyList[i].surveyId,
                surveyItemId: this.surveyList[i].itemId,
                answer: this.checkAnswer[j],
                itemClsfiCd: this.surveyList[i].itemClsfiCd,
                seqNo: response.data.data[j].seqNo,
              });
            }
          }


          if(this.checkAnswer.length === 0) {
            this.saveAnswerData.push({
                surveyId: this.surveyList[i].surveyId,
                surveyItemId: this.surveyList[i].itemId,
                answer: '',
                itemClsfiCd: this.surveyList[i].itemClsfiCd,
                seqNo: 1,
              });
          }


          continue;
        }

        if (this.surveyList[i].itemClsfiCd === 'G') {

            let params = {
            surveyId: this.surveyList[i].surveyId,
            surveyItemId: this.surveyList[i].itemId,
          }

          let response = await getSurveySeqNo(params);

          this.saveAnswerData.push({
            surveyId: this.surveyList[i].surveyId,
            surveyItemId: this.surveyList[i].itemId,
            answer: '0',
            itemClsfiCd: this.surveyList[i].itemClsfiCd,
            seqNo: response.data.data.length===0?0:response.data.data[0].seqNo,
          });

        } else {

          let params = {
            surveyId: this.surveyList[i].surveyId,
            surveyItemId: this.surveyList[i].itemId,
          }

          let response = await getSurveySeqNo(params);
          this.saveAnswerData.push({
            surveyId: this.surveyList[i].surveyId,
            surveyItemId: this.surveyList[i].itemId,
            answer: this.answer[i],
            itemClsfiCd: this.surveyList[i].itemClsfiCd,
            seqNo: response.data.data.length===0?0:response.data.data[0].seqNo,
          });
        }
      }

      const saveAnswerDataArr = this.saveAnswerData.filter((item, idx) => {
        return (
          this.saveAnswerData.findIndex(item1 => {
            return (
              item.surveyId === item1.surveyId &&
              item.surveyItemId === item1.surveyItemId &&
              item.answer === item1.answer
            );
          }) === idx
        );
      });

      for(let i=0; i<saveAnswerDataArr.length; i++) {
        if(saveAnswerDataArr[i].answer === '' && saveAnswerDataArr[i].itemClsfiCd !== 'G') {
          alert(i+1+'번 질문에 대한 답변을 입력하세요.');
          return;
        }
      }

      //alert(JSON.stringify(saveAnswerDataArr));
      //return;

      // eslint-disable-next-line no-unreachable
      const params = {
        saveAnswerData: saveAnswerDataArr,
      };

      let response = await saveSurveyAnswer(params);

      if (response.data.data > 0) {
        alert('설문조사를 종료 하였습니다');
      }

      this.$router.push(routerNames.SurveyBoxView);
    },
  },

  async mounted() {
    let params = {
      searchSurveyId: this.GET_ITEM.surveyId,
    };

    let response = await getBenSurveyDtl(params);
    this.surveyNm = response.data.data.surveyNm;
    this.surveyGuide = response.data.data.surveyGuide;

    response = await getBenSurveyAppQstItemList(params);
    this.surveyList = response.data.data;
    this.surveyCount = this.surveyList.length;

    for (let i = 0; i < this.surveyList.length; i++) {
      this.answer.push(
        isNaN(Number(this.surveyList[i].answer))
          ? this.surveyList[i].answer
          : Number(this.surveyList[i].answer) === 0
          ? ''
          : Number(this.surveyList[i].answer),
      );
    }

    // console.log('surveyList : ' + JSON.stringify(this.surveyList));
    // console.log('answer : ' + JSON.stringify(this.answer));

    params.itemId = this.surveyList[this.idx].itemId;
    response = await getBenSurveyAppAnsSelItemList(params);
    this.surveyAnsItemList = response.data.data;

    let checkArr;

    for (let i = 0; i < this.surveyList.length; i++) {
      if (this.surveyList[i].questType === 'M') {
        if (this.surveyList[i].answer !== null) {
          checkArr = this.surveyList[i].answer.split('|');
          for (let j=0; j<checkArr.length; j++) {
            this.checkAnswer.push(Number(checkArr[j]));
          }
        }
      }
    }

    this.checkUpdate(this.checkAnswer);
    console.dir(this.surveyAnsItemList);
  },
};
</script>

<style>
.v-application .primary--text {
  color: #3cb149 !important;
}

.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
</style>

